// extracted by mini-css-extract-plugin
export default {"wrapper":"StyledNumberInput_wrapper__BVV4f","dec":"StyledNumberInput_dec__mYgyZ","inc":"StyledNumberInput_inc__fcVt-","input":"StyledNumberInput_input__6MuSm"};